import CustomerJson, { defaultCustomerJson, validateMemberCustomerJson, validateRentalBookingCustomerJson, validateRentalBookingCustomerJsonRequest } from "./CustomerJson";
import SepaMandateJson, { validateSepaMandate } from "./SepaMandateJson";
import { Validation, ValidationResult } from "./Validation";

/**
 * Account um die Kundendaten zu speichern.
 */
export default interface RentalAccountJson {
    ID: number | null;

    /**
     * Kategorie als Freitextfeld, so dass je nach Kunde verschiedene Kategorien möglich sind. 
     * In den Settings sind mögliche Kategorien festlegbar. Standartmäßig: ["Privatperson", "Verband"]
     */
    type: string;

    /**
     * Kundendaten. Die E-Mail Adresse in Customer ist der Login-Benutzername.
     */
    customer: CustomerJson;

    /**
     * Optional ein Sepa-Mandat zum bezahlen von Verleihgegenständen.
     */
    sepaMandate: SepaMandateJson | null;
}

export type RentalAccountInfoJson = RentalAccountJson & { sepaMandate: boolean; };

export function defaultRentalAccountJson(): RentalAccountJson {
    return {
        ID: null,
        type: "",
        customer: defaultCustomerJson(),
        sepaMandate: null
    };
}

export function validateRentalAccountJson(json: RentalAccountJson): ValidationResult<RentalAccountJson> {
    return new Validation(json)
        .validateInteger("ID", 0, null, false)
        .validateNonEmptyString("type", 100)
        .validateUsingFunction("customer", validateRentalBookingCustomerJson)
        .validateUsingFunction("sepaMandate", validateSepaMandate, true)
        .finish();
}

export function validateRentalAccountJsonAdd(json: RentalAccountJson): ValidationResult<RentalAccountJson> {
    return new Validation(json)
        .validateEquals("ID", null)
        .validateNonEmptyString("type", 100)
        .validateUsingFunction("customer", validateRentalBookingCustomerJsonRequest)
        .validateUsingFunction("sepaMandate", validateSepaMandate, true)
        .finish();
}